<template>
	<div>
		<div class="form-group">
			<label class="col-xs-2 control-label">Статус кнопки:</label>
			<div class="col-xs-4 col-lg-4">
				<select name="settings[smart_button_is_enable]" class="oc-form__control" v-model="settings.smart_button_is_enable">
					<option value="0">Отключена</option>
					<option value="1">Включена</option>
				</select>
			</div>
		</div>
		<div class="form-group">
			<label class="col-xs-2 control-label">Кнопка на мобильных устройствах:</label>
			<div class="col-xs-4 col-lg-4">
				<select name="settings[smart_button_mobile_is_enabled]" class="oc-form__control" v-model="settings.smart_button_mobile_is_enabled">
					<option value="0">Скрыть</option>
					<option value="1">Показывать</option>
				</select>
			</div>
		</div>
		<div class="form-group">
			<label class="col-xs-2 control-label">Вид кнопки:</label>
			<div class="col-xs-4 col-lg-4">
				<select name="settings[smart_button_view_type]" class="oc-form__control" v-model="settings.smart_button_view_type">
					<option value="button">Кнопка</option>
					<option value="button-text">Кнопка с текстом</option>
					<option value="form">Форма</option>
				</select>
			</div>
		</div>
		<div class="form-group">
			<label class="col-xs-2 control-label">Цвет кнопки:</label>
			<div class="col-xs-4 col-lg-2">
				<div class="oc-color">
					<color-input :colors="color_button" @input="updateColor('color_button')($event)" />
				</div>
			</div>
		</div>
		<div class="form-group">
			<label class="col-xs-2 control-label">Цвет кнопки при наведении:</label>
			<div class="col-xs-4 col-lg-2">
				<div class="oc-color">
					<color-input :colors="color_button_hover" @input="updateColor('color_button_hover')($event)" />
				</div>
			</div>
		</div>
		<div class="form-group">
			<label class="col-xs-2 control-label">Цвет значка:</label>
			<div class="col-xs-4 col-lg-2">
				<div class="oc-color">
					<color-input :colors="color_icon" @input="updateColor('color_icon')($event)" />
				</div>
			</div>
		</div>
		<div class="form-group" v-if="is_form || is_button_text">
			<label class="col-xs-2 control-label">Цвет фона:</label>
			<div class="col-xs-4 col-lg-2">
				<div class="oc-color">
					<color-input :colors="color_background" @input="updateColor('color_background')($event)" />
				</div>
			</div>
		</div>
		<div class="form-group" v-if="is_button">
			<label class="col-xs-2 control-label">Текст подсказки:</label>
			<div class="col-xs-4 col-lg-2">
				<input type="text" class="oc-form__control" name="settings[smart_button_text_tooltip]" v-model="settings.smart_button_text_tooltip">
			</div>
		</div>
		<div class="form-group" v-if="is_form || is_button_text">
			<label class="col-xs-2 control-label" v-if="is_form">Текст рядом с формой:</label>
			<label class="col-xs-2 control-label" v-if="is_button_text">Текст рядом с кнопкой:</label>
			<div class="col-xs-4 col-lg-4">
				<input type="text" class="oc-form__control" name="settings[smart_button_text]" v-model="settings.smart_button_text" />
			</div>
		</div>
		<div class="form-group" v-if="is_form || is_button_text">
			<label class="col-xs-2 control-label" v-if="is_form">Цвет текста рядом с формой:</label>
			<label class="col-xs-2 control-label" v-if="is_button_text">Цвет текста рядом с кнопкой:</label>
			<div class="col-xs-4 col-lg-2">
				<div class="oc-color">
					<color-input :colors="color_text" @input="updateColor('color_text')($event)" />
				</div>
			</div>
		</div>
		<div class="form-group" v-if="is_form">
			<label class="col-xs-2 control-label">Цвет фона под формой:</label>
			<div class="col-xs-4 col-lg-2">
				<div class="oc-color">
					<color-input :colors="color_background_policy" @input="updateColor('color_background_policy')($event)" />
				</div>
			</div>
		</div>
		<div class="form-group" v-if="is_form">
			<label class="col-xs-2 control-label">Текст под формой:</label>
			<div class="col-xs-6 col-lg-6">
				<input type="text" class="oc-form__control" name="settings[smart_button_text_policy]" v-model="settings.smart_button_text_policy">
			</div>
		</div>
		<div class="form-group" v-if="is_form">
			<label class="col-xs-2 control-label">Цвет текста под формой:</label>
			<div class="col-xs-4 col-lg-2">
				<div class="oc-color">
					<color-input :colors="color_text_policy" @input="updateColor('color_text_policy')($event)" />
				</div>
			</div>
		</div>
		<div class="form-group">
			<label class="col-xs-2 control-label">Расположение:</label>
			<div class="col-xs-4 col-lg-2">
				<table class="position-table">
					<tr>
						<td><input type="radio" value="left-top" name="settings[smart_button_position]" v-model="settings.smart_button_position" /></td>
						<td><input type="radio" value="center-top" name="settings[smart_button_position]" v-model="settings.smart_button_position" /></td>
						<td><input type="radio" value="right-top" name="settings[smart_button_position]" v-model="settings.smart_button_position" /></td>
					</tr>
					<tr>
						<td><input type="radio" value="left-center" name="settings[smart_button_position]" v-model="settings.smart_button_position" /></td>
						<td></td>
						<td><input type="radio" value="right-center" name="settings[smart_button_position]" v-model="settings.smart_button_position" /></td>
					</tr>
					<tr>
						<td><input type="radio" value="left-bottom" name="settings[smart_button_position]" v-model="settings.smart_button_position" /></td>
						<td><input type="radio" value="center-bottom" name="settings[smart_button_position]" v-model="settings.smart_button_position" /></td>
						<td><input type="radio" value="right-bottom" name="settings[smart_button_position]" v-model="settings.smart_button_position" /></td>
					</tr>
				</table>
			</div>
		</div>
		<div class="form-group">
			<label class="col-xs-2 control-label">Отступ по горизонтали (в px):</label>
			<div class="col-xs-4 col-lg-2">
				<input type="text" class="oc-form__control" name="settings[smart_button_offset_x]" v-model="settings.smart_button_offset_x">
			</div>
		</div>
		<div class="form-group">
			<label class="col-xs-2 control-label">Отступ по вертикали (в px):</label>
			<div class="col-xs-4 col-lg-2">
				<input type="text" class="oc-form__control" name="settings[smart_button_offset_y]" v-model="settings.smart_button_offset_y">
			</div>
		</div>
		<div class="form-group">
			<label class="col-xs-2 control-label">z-index:</label>
			<div class="col-xs-4 col-lg-2">
				<input type="text" class="oc-form__control" name="settings[smart_button_z_index]" v-model="settings.smart_button_z_index">
			</div>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	import ColorInput from '../ColorInput.vue';

	export default Vue.extend({
		props: ['settings'],
		components: {
			ColorInput
		},
		data() {
			let data = [
				'color_button',
				'color_button_hover',
				'color_icon',
				'color_background',
				'color_text',
				'color_background_policy',
				'color_text_policy'
			].reduce((prev, current) => {
				prev[current] = {
					hex: this.settings['smart_button_' + current],
					a: parseFloat(this.settings['smart_button_' + current + '_opacity']) || 1
				};

				return prev;
			}, {});

			return data;
		},
		computed: {
			is_button: function () {
				return this.settings.smart_button_view_type === 'button';
			},
			is_form: function () {
				return this.settings.smart_button_view_type === 'form';
			},
			is_button_text: function () {
				return this.settings.smart_button_view_type === 'button-text';
			}
		},
		methods: {
			updateColor(prop_name) {
				return (colors) => {
					this.settings['smart_button_' + prop_name] = colors.hex;
					this.settings['smart_button_' + prop_name + '_opacity'] = colors.a;
					this[prop_name] = colors;
				};
			}
		}
	});
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/webpack/vue/settings/components/smart_button/SmartButton.vue